const n = {
  biggie: {
    size: 18,
    line: 26
  },
  large: {
    size: 16,
    line: 24
  },
  medium: {
    size: 15,
    line: 22
  },
  small: {
    size: 14,
    line: 20
  },
  teenie: {
    size: 13,
    line: 18
  }
}, t = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  heavy: 800
};
function s(e) {
  const i = n[e];
  return i ? `${i.size}px` : (console.error(`The requested font size definition (${e}) does not exist.`), "");
}
function o(e) {
  const i = n[e];
  return i ? `${i.line}px` : (console.error(`The requested line height definition (${e}) does not exist.`), "");
}
export {
  o as a,
  n as b,
  s as f,
  t
};
//# sourceMappingURL=text-B5Opw2za.mjs.map
